// @flow
import React from 'react';
import { DateLabel } from '@finect/tabular-components/DateLabel';
import { TextEllipsis } from '@finect/tabular-components/TextEllipsis';
import { Card, Question, Label, QuestionLink, AnswerLink, PublishedAt } from './partials';

/**
 * Tarjeta de una respuesta del asesor en la pestaña "Respuestas" de su perfil.
 *
 * Bloque vertical y limpio: pregunta enlazada (acción) + extracto de la respuesta en texto
 * legible (no en azul de enlace) + fecha. Sin la imagen-icono genérica anterior, para que la
 * lista ocupe el ancho de la columna principal y deje libre el espacio del sidebar.
 */
export const AnswerListCard = ({ profileAuthor, answer }: { profileAuthor: Object, answer: Object }) => {
  const { title, link } = answer;
  const answerProfile = answer.answers.find(ans => ans.author.id === profileAuthor.id);

  if (!answerProfile) return null;

  return (
    <Card>
      <Question>
        <Label>Pregunta:</Label>
        <QuestionLink href={link}>{title}</QuestionLink>
      </Question>

      <AnswerLink href={link}>
        <Label>Respuesta:</Label>
        <TextEllipsis lines={3}>{answerProfile.body.text}</TextEllipsis>
      </AnswerLink>

      <PublishedAt>
        <DateLabel date={new Date(answerProfile.updated)} format="LLL" />
      </PublishedAt>
    </Card>
  );
};
